export default "<mat-toolbar color=\"primary\">\n  <mat-toolbar-row>\n    <span> {{ appName }} {{ appVersion }} </span>\n  </mat-toolbar-row>\n</mat-toolbar>\n"